import { render, staticRenderFns } from "./create-edit-bloggrollstype.vue?vue&type=template&id=025f4326&scoped=true&"
import script from "./create-edit-bloggrollstype.vue?vue&type=script&lang=js&"
export * from "./create-edit-bloggrollstype.vue?vue&type=script&lang=js&"
import style0 from "./create-edit-bloggrollstype.vue?vue&type=style&index=0&id=025f4326&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f4326",
  null
  
)

export default component.exports